import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaCheckCircle, FaArrowLeft } from 'react-icons/fa';
import PageShell from '../components/PageShell';
import { siteConfig } from '../data/site';

const Obrigado = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      'Olá! Acabei de enviar o formulário de orçamento pelo site e gostaria de conversar sobre meu projeto.'
    );
    window.open(`https://wa.me/${siteConfig.whatsappNumber}?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <PageShell>
      <section className="pt-28 pb-20 md:pt-32 md:pb-28 min-h-[70vh] flex items-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <FaCheckCircle className="text-burnt text-5xl mx-auto mb-6" />
            <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-3">
              Solicitação enviada
            </p>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-4">
              Recebi seu pedido!
            </h1>
            <p className="text-lg text-dark/70 dark:text-cream/70 font-body leading-relaxed mb-8">
              Vou analisar as informações do seu projeto e retorno em até 24 horas pelo WhatsApp informado.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                type="button"
                onClick={handleWhatsApp}
                className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 shadow-lg"
              >
                <FaWhatsapp className="text-xl" />
                Falar agora no WhatsApp
              </button>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-base border-2 border-dark/15 dark:border-cream/20 text-dark dark:text-cream hover:border-burnt hover:text-burnt transition-colors"
              >
                <FaArrowLeft className="text-sm" />
                Voltar ao site
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </PageShell>
  );
};

export default Obrigado;
